import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login/loginView.vue')
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index/indexView.vue')
  },
  {
    path: '*',
    name:'notFindPage',
    component: () => import('@/views/404'),
    hidden: true
  },
]

const router = new VueRouter({
  routes
})

export default router
